import React, { Component } from "react";
import styles from "../../../../styles";
import robot from "../../../../../../assets/robot-05.svg";

const { PleaseWaitMainContainer, CircularLoading } = styles;

class PleaseWait extends Component {
  state = {};

  render() {
    return (
      <React.Fragment>
        <PleaseWaitMainContainer
          style={{
            position : this.props.position,
            width : this.props.width,
            height : this.props.height,
            top : this.props.top,
            left : this.props.left,
          }}
        >
          <img
            style={{ color: "rgb(86, 41, 182)", width: "250px" }}
            src={robot}
            alt="please wait"
          />
          <CircularLoading />
          <h3>{this.props.heading || "Please Wait"}</h3>
        </PleaseWaitMainContainer>
      </React.Fragment>
    );
  }
}

export default PleaseWait;
